'use client'

import { Textarea } from '@ui/primitives'

interface TabStudioProps {
  dictionary?: Record<string, string>
  partition: string
  onPartitionChange: (partition: string) => void
}

export function LazyTabStudio({ partition, onPartitionChange }: TabStudioProps) {
  return (
    <div className="space-y-4">
      <Textarea
        value={partition}
        onChange={(e) => onPartitionChange(e.target.value)}
        placeholder="Enter your tablature here..."
        rows={10}
      />
    </div>
  )
}
